/** Adults-only pravatar.cc IDs for Peeqd marketing mockups (skips low-number child photos). */
const PEEQD_ADULT_AVATARS = [
  11, 12, 13, 14, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  31, 32, 33, 34, 35, 36, 3, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
  51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
] as const;

export function peeqdAvatarUrl(size: number, index: number): string {
  const id = PEEQD_ADULT_AVATARS[Math.abs(index) % PEEQD_ADULT_AVATARS.length];
  return `https://i.pravatar.cc/${size}?img=${id}`;
}
